/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditEntry } from '../../models/audit-entry';

export interface List$Params {
  formId: string;
  entityClass: 'AuditRiskEntry' | 'AuditQualityEntry';
}

export function list(
  http: HttpClient,
  rootUrl: string,
  params: List$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<AuditEntry>>> {
  const rb = new RequestBuilder(rootUrl, list.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuditEntry>>;
    })
  );
}

list.PATH = '/auditing/forms/{formId}/{entityClass}';
